import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Skeleton,
  Text,
  VStack,
} from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Card } from "@src/components/ui-kit";
import { OurWorkProgressBar } from "@src/components/widgets/OurWorkProgressBar";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import type { ProjectModel } from "../models";
import { ProgressBar } from "../ProgressBar";
import { OurWorkTooltipLabel } from "../ProgressBar/OurWork";
import { CardHeader } from "./CardHeader";
import { NoBudgetItems } from "./NoBudgetItems";

interface OurWorkStatsCardProps {
  project: ProjectModel;
  isLoading?: boolean;
}

const OurWorkStatsCard = ({ project, isLoading }: OurWorkStatsCardProps) => {
  return (
    <Popover
      closeDelay={150}
      gutter={project.isTimeAndMaterials ? -100 : undefined}
      openDelay={150}
      trigger="hover"
    >
      <PopoverTrigger>
        <Card h="full" p="6">
          <VStack w="full" justify="space-between" h="full" align="stretch">
            <CardHeader title={t`Work`}>
              {!project.isTimeAndMaterials && (
                <Fragment>
                  <Text fontSize="md">{t`Budget`}:</Text>
                  <Text className="font-semibold" fontSize="md">
                    {currency.formatByWorkspace(
                      project.stats.ourWork.total_budget,
                    )}
                  </Text>
                </Fragment>
              )}
            </CardHeader>

            {!project.isTemplate &&
              (project.hasAnyOurWorkItem || isLoading ? (
                isLoading ? (
                  <>
                    <Skeleton h="8" rounded="full" />
                    <Skeleton h="2" rounded="full" />
                  </>
                ) : (
                  <ProgressBar.OurWork project={project}>
                    <OurWorkProgressBar
                      progress={project.lastWorkInProgressPercent ?? 0}
                    />
                  </ProgressBar.OurWork>
                )
              ) : (
                <NoBudgetItems />
              ))}
          </VStack>
        </Card>
      </PopoverTrigger>
      <PopoverContent
        maxW="256px"
        color="whiteAlpha.900"
        bg="grey.800"
        borderRadius="xl"
      >
        <OurWorkTooltipLabel
          stats={project.stats.ourWork}
          isTemplate={project.isTemplate}
          isTimeAndMaterials={project.isTimeAndMaterials}
        />
      </PopoverContent>
    </Popover>
  );
};

export default observer(OurWorkStatsCard);
